/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useDeleteEntityNote
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import { invalidateEntityNote } from 'app-constants/queryKeys';

/**
 * Mutate for delete entity note
 *
 */
const useDeleteEntityNote = (): UseMutationResult<unknown, IAxiosError, NoteDeleteModel, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (model) => {
			await api.NoteApi.deleteEntityNote(model);
		},
		onSuccess: () => {
			setTimeout(() => {
				invalidateEntityNote(queryClient);
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeleteEntityNote;
